<ion-content>
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="12" size-md="8" size-lg="6">
        <ion-list lines="full">
          @if (isLoading) {
            <ion-item lines="none">
              <ion-spinner name="crescent"></ion-spinner>
            </ion-item>
          }

          @for (user of users; track user.id) {
            <ion-item lines="full" class="user-item">
              <ion-label class="email">
                <h2>{{ user.email }}</h2>
              </ion-label>

              @let disabledByRole = (user.role === Role.ADMIN && !isAtLeastAdmin)
                || (user.role === Role.OWNER && !isAtLeastOwner
                || user.role === Role.INSTALLER && !isAtLeastInstaller);

              <ion-select
                interface="popover"
                [value]="user.role"
                (ionChange)="onRoleChange(user, $event.detail.value)"
                slot="end"
                [disabled]="disabledByRole"
                class="role-select"
              >

                  <ion-select-option [disabled]="!isAtLeastAdmin" [value]="Role.ADMIN">{{'ROLE.ADMIN' | translate}}</ion-select-option>
                  <ion-select-option [disabled]="!isAtLeastInstaller" [value]="Role.INSTALLER">{{'ROLE.INSTALLER' | translate}}</ion-select-option>
                  <ion-select-option [disabled]="!isAtLeastOwner" [value]="Role.OWNER">{{'ROLE.OWNER' | translate}}</ion-select-option>
                  <ion-select-option [disabled]="!isAtLeastOwner" [value]="Role.GUEST">{{'ROLE.GUEST' | translate}}</ion-select-option>

              </ion-select>

              <ion-button
                fill="clear"
                color="danger"
                size="small"
                slot="end"
                [disabled]="disabledByRole"
                (click)="deleteUser(user)"
              >
                <ion-icon name="trash-outline"></ion-icon>
              </ion-button>
            </ion-item>
          }
          <ion-infinite-scroll (ionInfinite)="doInfinite($event)">
            <ion-infinite-scroll-content [loadingSpinner]="'crescent'" ngClass="custom-spinner"></ion-infinite-scroll-content>
          </ion-infinite-scroll>
        </ion-list>

        <!-- Add-Button for desktop devices -->
        @if (!this.service.isSmartphoneResolution) {
          <ion-fab style="position: fixed; margin-top: 10%; display: block;" vertical="bottom" horizontal="center"
                   testId="ibn-button">
            <ion-fab-button size="large">
              <ion-icon name="add-outline"></ion-icon>
            </ion-fab-button>
            <ion-fab-list side="top" style="left: 0; align-items: flex-start;" id="blurred">
              <oe-flat-button color="primary" [link]="{ text: 'invite', routeRelative: route}">
                {{"REGISTER.USERS.ADD" | translate: {edgeShortName: environment.edgeShortName} }}
              </oe-flat-button>
            </ion-fab-list>
          </ion-fab>
        }

        <!-- Add-Button for mobile devices -->
        @if (this.service.isSmartphoneResolution) {
          <ion-fab style="position: fixed;" horizontal="end" vertical="bottom" testId="ibn-button">
            <ion-fab-button size="small">
              <ion-icon name="add-outline"></ion-icon>
            </ion-fab-button>
            <ion-fab-list side="top" style="right: 0; align-items: flex-end;">
              <ion-button color="primary" [routerLink]="['./invite']" routerLinkActive="active" translate
                          [translateParams]="{edgeShortName: environment.edgeShortName}">REGISTER.USERS.ADD</ion-button>
            </ion-fab-list>
          </ion-fab>
        }

      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
